import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function PoolAvailableIcon({ color = "lightblack" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 12.9998L3.87978 11.9441C4.7068 10.9517 6.24341 10.9911 7.01852 12.0245C7.78176 13.0422 9.28828 13.099 10.1259 12.1416L10.3169 11.9234C11.2079 10.9051 12.7921 10.9051 13.6831 11.9234L13.8741 12.1416C14.7117 13.099 16.2182 13.0422 16.9815 12.0245C17.7566 10.9911 19.2932 10.9517 20.1202 11.9441L21 12.9998M3 17.9998L3.87978 16.9441C4.7068 15.9517 6.24341 15.9911 7.01852 17.0245C7.78176 18.0422 9.28828 18.099 10.1259 17.1416L10.3169 16.9234C11.2079 15.9051 12.7921 15.9051 13.6831 16.9234L13.8741 17.1416C14.7117 18.099 16.2182 18.0422 16.9815 17.0245C17.7566 15.9911 19.2932 15.9517 20.1202 16.9441L21 17.9998M3 7.99984L3.87978 6.9441C4.7068 5.95168 6.24341 5.99105 7.01852 7.02453C7.78176 8.04218 9.28828 8.09895 10.1259 7.14163L10.3169 6.92342C11.2079 5.90508 12.7921 5.90508 13.6831 6.92342L13.8741 7.14163C14.7117 8.09895 16.2182 8.04218 16.9815 7.02453C17.7566 5.99105 19.2932 5.95168 20.1202 6.9441L21 7.99984"
        stroke={COLORS[color]}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
